import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    defaultMessage: 'Add Payment Method',
    description: 'Header text for the add payment method modal',
    id: '2z+Zp2',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    description: 'Text for the cancel button in the manage payment method flow',
    id: 'FW8sIS',
  },
  saveButton: {
    defaultMessage: 'Save',
    description: 'Text for the save button in the manage payment method flow',
    id: 'qzQG1q',
  },
});
